import config from '../package.json';
const ID = `${config.name}/actions/modalAction`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const INSURED_SHARE = createActionName('INSURED_SHARE');
export const INSURED_COPY = createActionName('INSURED_COPY');
export const INSURED_REQUEST_ACCESS = createActionName(
  'INSURED_REQUEST_ACCESS',
);
export const INSURED_COPY_REQUEST_ACCESS = createActionName(
  'INSURED_COPY_REQUEST_ACCESS',
);

export const POPUP_NOT_SHOW_AGAIN = createActionName('POPUP_NOT_SHOW_AGAIN');

export const AXA_GOAL_INSURED_SHARE = createActionName(
  'AXA_GOAL_INSURED_SHARE',
);
export const AXA_GOAL_INSURED_COPY = createActionName('AXA_GOAL_INSURED_COPY');
